/*
 * Intercepts .cps-form product forms so cart errors (e.g. quantity limits)
 * are shown in a toast popup instead of navigating to Shopify's /cart/add error page.
 */
(function () {
  function showToast(message) {
    var toast = document.getElementById('cps-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cps-cart-toast';
      toast.className = 'cps-cart-toast';
      toast.setAttribute('role', 'alert');
      toast.innerHTML =
        '<span class="cps-cart-toast__icon">!</span>' +
        '<span class="cps-cart-toast__text"></span>' +
        '<button type="button" class="cps-cart-toast__close" aria-label="Close">&times;</button>';
      toast.querySelector('.cps-cart-toast__close').addEventListener('click', function () {
        toast.classList.remove('cps-cart-toast--visible');
      });
      document.body.appendChild(toast);
    }
    toast.querySelector('.cps-cart-toast__text').textContent = message;
    toast.classList.add('cps-cart-toast--visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('cps-cart-toast--visible');
    }, 6000);
  }

  function friendlyMessage(rawMessage) {
    if (!rawMessage) return 'Unable to add this item to your cart.';

    // Shopify quantity-rule error, e.g.
    // "5TRIP Energy Sample Pack (4pcs): Quantity error — You can only have up to 1 items but have 2."
    var limitMatch = rawMessage.match(/up to (\d+)/i);
    if (/quantity error/i.test(rawMessage) && limitMatch) {
      var limit = parseInt(limitMatch[1], 10);
      if (limit === 1) {
        return 'This item is limited to 1 per customer, and it\u2019s already in your cart.';
      }
      return 'This item is limited to ' + limit + ' per customer. You\u2019ve already reached that limit in your cart.';
    }

    if (/sold out|out of stock/i.test(rawMessage)) {
      return 'Sorry, this item is sold out.';
    }

    if (/all \d+|only \d+ left|items? left/i.test(rawMessage)) {
      return 'Sorry, we don\u2019t have enough stock to add more of this item.';
    }

    return rawMessage;
  }

  function bindForm(form) {
    if (form.dataset.cpsAjaxBound) return;
    form.dataset.cpsAjaxBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      var formData = new FormData(form);

      // The AJAX endpoint returns JSON; the cart drawer is opened on success.
      formData.delete('return_to');
      // An empty selling_plan param can cause a cart error
      if (!formData.get('selling_plan')) formData.delete('selling_plan');

      if (button) {
        button.disabled = true;
        button.classList.add('cps-atc-btn--loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          // if (result.ok) {
          //   // Skip slideout cart and go straight to checkout on configured pages
          //   if (form.getAttribute('data-direct-checkout') === 'true') {
          //     window.location.href = '/checkout';
          //     return;
          //   }
          //   if (typeof window.refreshAndOpenCartDrawer === 'function') {
          //     window.refreshAndOpenCartDrawer();
          //   } else {
          //     window.location.href = '/cart';
          //   }
          //   if (button) {
          //     button.disabled = false;
          //     button.classList.remove('cps-atc-btn--loading');
          //   }
          //   return;
          // }
           if (result.ok) {
            // Force every successful add-to-cart straight to checkout
            window.location.href = '/checkout';
            return;
          }
          showToast(friendlyMessage(result.data.description || result.data.message));
          if (button) {
            button.disabled = false;
            button.classList.remove('cps-atc-btn--loading');
          }
        })
        .catch(function () {
          showToast('Something went wrong. Please try again.');
          if (button) {
            button.disabled = false;
            button.classList.remove('cps-atc-btn--loading');
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('form.cps-form').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
